import React, { useState } from 'react';

const PaymentComponent = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [amount, setAmount] = useState('25');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [requestOk, setRequestOk] = useState(false);


  const transformPhoneNumber = (inputNumber) => {
    // Remove any non-digit characters (e.g., spaces, dashes)
    const cleanNumber = inputNumber.replace(/\D/g, '');
  
    if (cleanNumber.startsWith('0') && cleanNumber.length === 10) {
      // If the number starts with "0" and has 10 digits
      return `254${cleanNumber.slice(1)}`;
    } else if (cleanNumber.startsWith('+254') && (cleanNumber.length !== 13)) {
      // If the number starts with "+254" and has more than 13 digits or less than 13 digits, it is invalid
      return null;  
    } else if (cleanNumber.startsWith('0') && cleanNumber.length !== 10) {
      // If the number starts with "0",it should have 10 digits
      return null
    } else {
      // Otherwise, return null to indicate an invalid number
      return null;
    }
  };
  

  const handlePayment = async (e) => {
    e.preventDefault()
    // Transform the phone number before sending it to the server
    const transformedPhoneNumber = transformPhoneNumber(phoneNumber);
    console.log(transformedPhoneNumber);

      // Check if the phone number is valid
      if (transformedPhoneNumber === null) {
        // There is an error in the phone number
        setError("Enter a valid number");
        setTimeout(()=>{
          setError("");
        },[3000])
        return;
      }
    try {
      setIsLoading(true); // Set loading state to true

      const response = await fetch('https://campus-closet-server.vercel.app/api/payment', { // Send a request to your server's payment endpoint
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount,
          phoneNumber: transformedPhoneNumber,
        }),
      });

      if (response.ok) {
          // Process the payment response or perform any necessary actions
        const paymentResponse = await response.json();
        console.log(paymentResponse);
        setRequestOk(`Request successful. check on ${phoneNumber} to complete transaction`)
        setTimeout(()=>{
            setRequestOk("")
        },[7000])
        setAmount("")
        setPhoneNumber("")
      } else {
        throw new Error('Payment request failed');
      }
      setIsLoading(false); // Set loading state back to false
    } catch (error) {
        console.log(error);
      setIsLoading(false); // Set loading state back to false
      setError(true); // Set the error message
      setTimeout(()=>{
          setError(false); // Set the error message
      },[3000])
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Payment</h1>
      <div className="bg-white shadow-md rounded-lg p-6 mb-4">
        <h2 className="text-xl font-bold mb-4">Order Summary</h2>
        <div className="flex justify-between mb-2">
          <span>Item 1</span>
          <span>KSh10.00</span>
        </div>
        <div className="flex justify-between mb-2">
          <span>Item 2</span>
          <span>KSh15.00</span>
        </div>
        <div className="border-t border-gray-300 mt-2 pt-2">
          <div className="flex justify-between">
            <span className="font-bold">Total:</span>
            <span className="font-bold">kSh25.00</span>
          </div>
        </div>
      </div>

      <form onSubmit={handlePayment} className="bg-white shadow-md rounded-lg p-6">
        <h2 className="text-xl font-bold mb-4">M-Pesa Payment</h2>
        <div className="mb-4">
          <label htmlFor="phone" className="block text-gray-700 font-bold mb-2">
            Phone Number:
          </label>
          <input
            type="text"
            id="phone"
            className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter your phone number"
            value={phoneNumber}
            required
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
        </div>
        <button type='submit'  className="bg-blue-500 text-white px-4 py-2 rounded font-bold">
          {isLoading ? 'Processing...' : ' Pay with M-Pesa'}
        </button>
      </form>
      {requestOk && <p className="text-green-500 font-bold">{requestOk}</p>}
     {error && <p className="text-red-500">{error}</p>}
    </div>
  );
};

export default PaymentComponent;
